export default __webpack_public_path__ + "static/media/nossoTime.ba64656f.svg";